<template>
	<DefaultLayout
		v-if="canShowRouterView"
		class="app-authorized-window"
	>
		<router-view/>

		<NotificationProvider />
	</DefaultLayout>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'

import DefaultLayout  from '@/layouts/DefaultLayout.vue'
import NotificationProvider from '@/components/provides/NotificationProvider.vue'

/* Composables */
import useAuth from '@/composables/useAuth'

/* Stores */
import { useUserStore } from '@/stores/userStore'
import { useCompanyStore } from '@/stores/companyStore'
import { useCompanyNotificationStore } from '@/stores/companyNotificationStore'
import { useCompanyFavoriteLinksStore } from '@/stores/companyFavoriteLinksStore'
import { useApplicationStore } from '@/stores/applicationStore'

const router = useRouter()

const userStore = useUserStore()
const {
	availableCompanies,
} = storeToRefs(userStore)
const {
	setSelectedCompanyId,
} = userStore

const companyStore = useCompanyStore()
const companyNotificationStore = useCompanyNotificationStore()
const companyFavoriteLinksStore = useCompanyFavoriteLinksStore()
const applicationStore = useApplicationStore()

const {
	getDefinedCompanyId,
} = useAuth()

const canShowRouterView = ref(false)

onMounted(() => {
	if (Array.isArray(availableCompanies.value) && availableCompanies.value.length === 0) {
		router.push({ name: 'CreateCompanyPage' })
	}

	// загрузить юзера и список компаний
	getDefinedCompanyId(availableCompanies.value)
		.then((companyId) => {
			// console.log('getDefinedCompanyId - then: companyId', companyId)
			if (companyId) {
				setSelectedCompanyId(companyId)
					.then(() => {
						canShowRouterView.value = true
					})
			} else {
				canShowRouterView.value = true
			}
		})
})

onUnmounted(() => {
	companyStore.$reset()
	applicationStore.$reset()
	companyFavoriteLinksStore.$reset()
	companyNotificationStore.reset()
})
</script>
